// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"79514a9a","650":"1fb9b693","782":"37792441","796":"5ef6addd"}[chunkId] + ".chunk.css";
};